module.exports = __webpack_public_path__ + "static/tom_gamble-7b3c910debb9e28949c63ce7d97ad252.jpg";